import { TEAM_HOME } from 'router/routerConstants';

export const ALL_TOKENS = {
	path: `${TEAM_HOME.path}/all`,
};

export const MY_TOKENS = {
	path: `${TEAM_HOME.path}/my`,
};

export const TEAM_DETAILS = {
	path: `${TEAM_HOME.path}/details`,
};

export const POST_DETAIL = {
	path: `${TEAM_HOME.path}/post/:postId`,
};

export const TEAM_LEADERBOARD = {
	path: `${TEAM_DETAILS.path}/leaderboard`,
};

export const TEAM_DETAILS_SETTINGS = {
	path: `${TEAM_DETAILS.path}/settings`,
};

export const TEAM_DETAILS_USERS = {
	path: `${TEAM_DETAILS.path}/users`,
};

export const TEAM_DETAILS_BADGES = {
	path: `${TEAM_DETAILS.path}/badges`,
};

export const TEAM_USER_STATS = {
	path: `${TEAM_HOME.path}/stats`,
};
